module.exports = __webpack_public_path__ + "static/img/1404.9312ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/1404.png
// module id = 6bm5
// module chunks = 0